import { createFileRoute, redirect } from "@tanstack/react-router";

// About now lives inside Settings; keep old deep links working.
export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/about")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/projects/$projectSlug/settings",
      params,
      hash: "about",
      replace: true,
    });
  },
});
